import Vue from 'vue'
import { StylesParser } from '../StylesParser'
import { SectionBuilder } from './SectionBuilder'
import * as Components from '../EditorComponents'
import { ClassesBuilder } from "./ClassesBuilder";

export class ComponentBuilder {
  constructor(component) {
    this.component = component
  }

  build() {
    this.componentAssets = this.getComponentAssets()
    this.ids = this.getIds()
    this.componentClasses = this.getComponentClasses()
    this.componentContent = this.getComponentContent()
    this.getComponentStyles()
    this.id = this.component.id
    return this.buildHtml()
  }

  buildHtml() {
    return (new Components[this.component.name]).elementHtml(this.ids, this.componentClasses, this.componentContent, this.componentAssets)
  }

  getComponentAssets() {
    return Object.keys(this.component.assets).map(device => this.component.assets[device]).flat(1)
  }

  getComponentContent() {
    let component = new Components[this.component.name]
    let elementContents = component.elementContents()
    let componentContents = {}
    for (let componentProperty in this.component.content) {
      if (! elementContents.includes(componentProperty)) {
        continue
      }
      Vue.set(
        componentContents,
        componentProperty,
        this.component.content[componentProperty]
      )
    }
    if (Object.prototype.hasOwnProperty.call(this.component, 'sections')) {
      let componentSections = this.component.sections.map(section => ({
        html: new SectionBuilder(section).build(),
        content: section.content,
        id: section.id
      }))
      Vue.set(
        componentContents,
        'sections',
        componentSections
      )
    }
    return componentContents
  }

  getComponentStyles() {
    let component = new Components[this.component.name]
    let elementStyles = component.elementStyles()
    elementStyles.forEach(elementId => {
      let styles = {}
      if (elementId.element == 'id') {
        Vue.set(styles, 'id', `${elementId.selector}${this.ids[elementId.id]}`)
      }
      if (elementId.element == 'class') {
        Vue.set(styles, 'id', `${elementId.selector}${elementId.suffix ? elementId.suffix : ''}`)
      }
      Vue.set(styles, elementId.styles, {})
      Vue.set(styles[elementId.styles], 'desktop', (new StylesParser(this.component[elementId.styles], 'desktop')).parse())
      Vue.set(styles[elementId.styles], 'tablet', (new StylesParser(this.component[elementId.styles], 'tablet')).parse())
      Vue.set(styles[elementId.styles], 'phone', (new StylesParser(this.component[elementId.styles], 'phone')).parse())
      window.StylesBuilder.add(styles)
    })
  }

  getIds() {
    let component = new Components[this.component.name]
    let elementIds = component.elementIds()
    let componentIds = {}
    for (let componentProperty in this.component) {
      if (! elementIds.includes(componentProperty)) {
        continue
      }
      Vue.set(
        componentIds,
        componentProperty,
        this.component[componentProperty]
      )
    }
    return componentIds
  }

  getComponentClasses() {
    let component = new Components[this.component.name]
    let elementClasses = component.elementClasses()
    let componentClasses = {}
    for (let componentProperty in this.component) {
      if (! elementClasses.includes(componentProperty)) {
        continue
      }
      Vue.set(
        componentClasses,
        componentProperty,
        (new ClassesBuilder(this.component[componentProperty])).parseClasses().join(' ')
      )
    }
    return componentClasses
  }
}
